export enum TipoConsultaEnum {
    PROCESO = '0',
    PLANEACION = '1',
    ADMINISTRACION = '-1'
}
